// extracted by mini-css-extract-plugin
export var dividerLine = "_3g-0";
export var errorBackground = "_3g-1";